import React from 'react';
import cn from 'classnames';
import styles from './Counter.module.css';
export const Counter = props => {
  const {
    length,
    maxLength
  } = props;
  return /*#__PURE__*/React.createElement("span", {
    className: cn({
      [styles.counter]: true,
      [styles.counter_error]: length > maxLength
    })
  }, length, "/", maxLength);
};